// Données globales du site EDUCASER GROUP.
import { CATEGORIES, getFormationsByCategory } from "./formations";

export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/0fsui88y_EDUCASER%20logos.ai_page-0001.jpg";

export const SITE = {
  name: "EDUCASER GROUP",
  baseline: "Regroupement d'organismes de formation dédié aux métiers de la route et de la mobilité",
  url: typeof window !== "undefined" ? window.location.origin : "https://educaser.fr",
};

export const CONTACTS = {
  enseignants: {
    label: "Formation Enseignants",
    email: "contact@educaser.fr",
    telephone: "01 69 09 27 27",
    adresse: "4 Allée des Garays, 91120 Palaiseau",
  },
  groupeLourd: {
    label: "Formation Groupe Lourd",
    email: "formationcamo@gmail.com",
    telephone: "07 81 52 48 73",
    adresses: [
      "7–9 Rue Saint-Just, 93130 Noisy-le-Sec",
      "6 Cours Raoult, 77100 Meaux",
    ],
  },
};

export const CENTRES = [
  {
    id: "noisy-le-sec",
    ville: "Noisy-le-Sec",
    nom: "Centre Groupe Lourd & Enseignants — Noisy-le-Sec",
    adresse: "7–9 Rue Saint-Just, 93130 Noisy-le-Sec",
    email: "formationcamo@gmail.com",
    telephone: "07 81 52 48 73",
    phones: [
      { num: "07 81 52 48 73", label: "Formation groupe lourd" },
      { num: "07 66 94 05 26", label: "Formation enseignement" },
    ],
    emails: [
      { addr: "formationcamo@gmail.com", label: "Formation groupe lourd" },
      { addr: "Noisy@educaser.fr", label: "Formation enseignement" },
    ],
    tag: ["Formation groupe lourd", "Formation enseignant de la conduite et de la sécurité routière"],
    mapQuery: "7 Rue Saint-Just, 93130 Noisy-le-Sec",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wwu0mne8_PHOTO-2026-07-20-15-11-26.jpg",
  },
  {
    id: "palaiseau",
    ville: "Palaiseau",
    nom: "Centre Enseignants — Palaiseau",
    adresse: "4 Allée des Garays, 91120 Palaiseau",
    email: "contact@educaser.fr",
    telephone: "01 69 09 27 27",
    tag: "Formation enseignant de la conduite et de la sécurité routière",
    mapQuery: "4 Allée des Garays, 91120 Palaiseau",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/hzj7f9yq_PHOTO-2026-07-21-12-01-25.webp",
  },
  {
    id: "meaux",
    ville: "Meaux",
    nom: "Centre Groupe Lourd — Meaux",
    adresse: "6 Cours Raoult, 77100 Meaux",
    email: "formationcamo@gmail.com",
    telephone: "07 81 52 48 73",
    tag: "Formation groupe lourd",
    mapQuery: "6 Cours Raoult, 77100 Meaux",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/zmgut7cz_PHOTO-2026-07-16-13-48-51.webp",
  },
  {
    id: "choisy-le-roi",
    ville: "Choisy-le-Roi",
    nom: "Centre Enseignants — Choisy-le-Roi",
    adresse: "1 Place des Alliés, 94600 Choisy-le-Roi",
    email: "Choisy@educaser.fr",
    telephone: "06 12 57 81 08",
    tag: "Formation enseignant de la conduite et de la sécurité routière",
    mapQuery: "1 Place des Alliés, 94600 Choisy-le-Roi",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/q8tle8n0_unnamed.webp",
  },
  {
    id: "pontault-combault",
    ville: "Pontault-Combault",
    nom: "Centre — Pontault-Combault",
    adresse: "10 Avenue du Général de Gaulle, 77340 Pontault-Combault",
    tag: [
      "Formation enseignant de la conduite et de la sécurité routière",
      "Formation groupe lourd",
      "Récupération de points",
    ],
    mapQuery: "10 Avenue du Général de Gaulle, 77340 Pontault-Combault",
  },
  {
    id: "roissy-en-france",
    ville: "Roissy-en-France",
    nom: "Centre — Roissy-en-France",
    adresse: "58 Rue de la Belle Étoile, 95700 Roissy-en-France",
    tag: [
      "Formation enseignant de la conduite et de la sécurité routière",
      "Formation groupe lourd",
      "Récupération de points",
    ],
    mapQuery: "58 Rue de la Belle Étoile, 95700 Roissy-en-France",
  },
  {
    id: "le-plessis-belleville",
    ville: "Le Plessis-Belleville",
    nom: "Centre — Le Plessis-Belleville",
    adresse: "4 Avenue de la Gare, 60330 Le Plessis-Belleville",
    tag: [
      "Formation enseignant de la conduite et de la sécurité routière",
      "Formation groupe lourd",
      "Récupération de points",
    ],
    mapQuery: "4 Avenue de la Gare, 60330 Le Plessis-Belleville",
  },
];

export const STATS = [
  { value: 15, suffix: "", label: "Années d'expertise" },
  { value: 12, suffix: "", label: "Formations certifiantes" },
  { value: 7, suffix: "", label: "Centres de formation" },
  { value: 95, suffix: "%", label: "Taux de satisfaction" },
];

export const WHY = [
  {
    title: "Organismes certifiés qualité",
    text: "Chaque centre du regroupement dispose de sa propre certification qualité pour garantir la qualité des formations.",
    icon: "BadgeCheck",
  },
  {
    title: "Formateurs experts",
    text: "Des enseignants issus du secteur du transport, titulaires du TP ECSR mention groupe lourd.",
    icon: "Users",
  },
  {
    title: "Moyens performants",
    text: "Simulateurs haut de gamme, véhicules en double commande et plateforme E-formapro.",
    icon: "Cpu",
  },
  {
    title: "Accompagnement financement",
    text: "Un conseil personnalisé pour optimiser votre budget : CPF, France Travail, OPCO, entreprise.",
    icon: "Wallet",
  },
  {
    title: "7 centres de formation",
    text: "Palaiseau, Noisy-le-Sec, Meaux, Choisy-le-Roi, Pontault-Combault, Roissy-en-France et Le Plessis-Belleville.",
    icon: "MapPin",
  },
  {
    title: "Diplômes reconnus",
    text: "Titres professionnels inscrits au RNCP et cartes de qualification de conducteur (CQC).",
    icon: "GraduationCap",
  },
];

export const DOMAINES = CATEGORIES.map((c) => ({
  ...c,
  count: getFormationsByCategory(c.slug).length,
}));

export const FINANCEMENTS = [
  {
    id: "cpf",
    nom: "CPF",
    titre: "Compte Personnel de Formation",
    text: "Le CPF peut financer tout ou partie de votre formation. En 2026, une participation financière obligatoire de 150 € s'applique, sauf cas d'exonération prévus par la réglementation. Le montant définitif et les éventuels abondements sont confirmés sur Mon Compte Formation.",
    icon: "Wallet",
  },
  {
    id: "france-travail",
    nom: "France Travail",
    titre: "Demandeurs d'emploi",
    text: "En tant que demandeur d'emploi, plusieurs dispositifs de France Travail (AIF, POE, etc.) peuvent financer votre reconversion, selon votre situation et après validation du financeur.",
    icon: "Briefcase",
  },
  {
    id: "opco",
    nom: "OPCO",
    titre: "Opérateurs de compétences",
    text: "Les OPCO peuvent prendre en charge les formations de vos salariés dans le cadre du plan de développement des compétences, sous réserve d'éligibilité.",
    icon: "Building2",
  },
  {
    id: "entreprise",
    nom: "Entreprise",
    titre: "Financement employeur",
    text: "Votre entreprise peut financer directement votre montée en compétences et l'obtention des qualifications obligatoires (FIMO, FCO).",
    icon: "Factory",
  },
  {
    id: "transitions-pro",
    nom: "Transitions Pro",
    titre: "Projet de transition professionnelle",
    text: "Le Projet de Transition Professionnelle (PTP) permet aux salariés de suivre une formation certifiante pour changer de métier, avec maintien de la rémunération sous conditions.",
    icon: "RefreshCw",
  },
  {
    id: "handicap",
    nom: "Handicap",
    titre: "Agefiph & FIPHFP",
    text: "L'Agefiph peut participer au financement d'une formation et des adaptations rendues nécessaires par le handicap. Selon votre situation, Cap emploi, France Travail et le FIPHFP peuvent également intervenir.",
    icon: "Accessibility",
  },
  {
    id: "autres",
    nom: "Autres dispositifs",
    titre: "Autres dispositifs & Région",
    text: "Selon votre situation et sous réserve d'éligibilité (aides régionales, financement personnel, paiement échelonné), nos équipes vous établissent un devis et vous accompagnent après validation du financeur.",
    icon: "HandCoins",
  },
];

export const FAQ = [
  {
    q: "Qu'est-ce que la FIMO et la FCO ?",
    a: "La FIMO (Formation Initiale Minimale Obligatoire) est requise pour débuter dans la conduite professionnelle. La FCO (Formation Continue Obligatoire) doit être renouvelée tous les 5 ans pour maintenir la Carte de Qualification de Conducteur (CQC).",
  },
  {
    q: "Vos formations sont-elles finançables ?",
    a: "Oui. Contactez nos équipes qui pourront vous établir un devis et vous accompagner dans l'optimisation de votre budget avec les différents types de financement auxquels vous pouvez prétendre (CPF, France Travail, OPCO, entreprise).",
  },
  {
    q: "Où se déroulent les formations ?",
    a: "Nos formations se déroulent dans nos quatre centres d'Île-de-France : Palaiseau (91), Noisy-le-Sec (93), Meaux (77) et Choisy-le-Roi (94).",
  },
  {
    q: "Vos centres sont-ils certifiés ?",
    a: "Chaque centre du regroupement EDUCASER GROUP dispose des agréments délivrés par les autorités compétentes (préfecture, DREAL, DRIEETS) selon les formations, ainsi que d'une démarche qualité certifiée Qualiopi.",
  },
  {
    q: "Comment s'inscrire à une formation ?",
    a: "Vous pouvez demander un devis, être rappelé ou nous contacter directement via le formulaire. Nos équipes vous accompagnent dans votre inscription et le montage de votre dossier de financement.",
  },
  {
    q: "Les formations sont-elles accessibles aux personnes en situation de handicap ?",
    a: "Les personnes en situation de handicap peuvent avoir des besoins spécifiques pour suivre la formation, n'hésitez pas à nous contacter pour en discuter.",
  },
];

export const SESSIONS = [
  { formation: "FIMO Marchandises", centre: "Noisy-le-Sec", date: "Prochaine session", places: "Places disponibles" },
  { formation: "FCO Voyageurs", centre: "Meaux", date: "Prochaine session", places: "Places disponibles" },
  { formation: "TP – Enseignant ECSR", centre: "Palaiseau", date: "Prochaine session", places: "Sur dossier" },
  { formation: "Permis CE", centre: "Noisy-le-Sec", date: "Prochaine session", places: "Places limitées" },
];

export const CTA_OPTIONS = [
  { type: "devis", label: "Demander un devis" },
  { type: "rappel", label: "Être rappelé" },
  { type: "inscription", label: "S'inscrire" },
];

// Informations légales (source : registre RCS / Pappers).
export const LEGAL = {
  raisonSociale: "NTER FORMATIONS SECURITE ROUTIERE",
  enseigne: "EDUCASER GROUP",
  formeJuridique: "SAS — Société par actions simplifiée",
  capital: "13 500 €",
  siren: "753 953 116",
  siret: "753 953 116 00039",
  tva: "FR71753953116",
  rcs: "753 953 116 R.C.S. Evry",
  naf: "85.59A — Formation continue d'adultes",
  siege: "4 Allée des Garays, 91120 Palaiseau",
  president: "Hichem Bouallegue",
  creation: "1er octobre 2012",
  directeurPublication: "Hichem Bouallegue",
  // À confirmer par EDUCASER
  nda: "11 91 XXXXX 91",
  hebergeur: "Hébergeur à préciser",
};

// Indicateurs de résultats (données d'exemple — à mettre à jour chaque année).
export const RESULTATS = {
  annee: 2025,
  maj: "Février 2026",
  global: [
    { label: "Taux de satisfaction", value: "96,4%", icon: "Smile" },
    { label: "Taux de réussite global", value: "91,8%", icon: "Trophy" },
    { label: "Taux d'abandon", value: "3,2%", icon: "TrendingDown" },
    { label: "Stagiaires formés", value: "512", icon: "Users" },
    { label: "Taux d'obtention du diplôme", value: "89,5%", icon: "GraduationCap" },
    { label: "Insertion professionnelle", value: "76%", icon: "Briefcase" },
  ],
  parFormation: [
    { formation: "Permis C", reussite: "93,4%", satisfaction: "96,8%", stagiaires: 104 },
    { formation: "Permis CE", reussite: "90,7%", satisfaction: "95,2%", stagiaires: 81 },
    { formation: "Permis D", reussite: "89,3%", satisfaction: "96,1%", stagiaires: 58 },
    { formation: "FIMO / FCO", reussite: "97,6%", satisfaction: "98,0%", stagiaires: 147 },
    { formation: "TP Enseignant ECSR", reussite: "87,9%", satisfaction: "94,7%", stagiaires: 46 },
  ],
};

// Documents utiles (mis à disposition sur demande ou en téléchargement).
export const DOCUMENTS = [
  { id: "reglement-interieur", titre: "Règlement intérieur", description: "Règles de fonctionnement, d'hygiène et de sécurité applicables aux stagiaires.", icon: "ScrollText" },
  { id: "livret-accueil", titre: "Livret d'accueil du stagiaire", description: "Informations pratiques, déroulement des formations et vie du centre.", icon: "BookOpen" },
  { id: "charte-qualite", titre: "Charte qualité", description: "Nos engagements qualité dans le cadre de la certification Qualiopi.", icon: "BadgeCheck" },
  { id: "procedure-reclamation", titre: "Procédure de réclamation", description: "Comment formuler une réclamation et modalités de traitement.", icon: "MessageSquareWarning" },
  { id: "procedure-handicap", titre: "Procédure d'accessibilité handicap", description: "Modalités d'adaptation et contact du référent handicap.", icon: "Accessibility" },
  { id: "cgv", titre: "Conditions générales de vente", description: "Conditions applicables aux prestations de formation.", icon: "FileCheck" },
  { id: "nda", titre: "Attestation de déclaration d'activité (NDA)", description: "Numéro de déclaration d'activité de l'organisme de formation auprès de la préfecture de région.", icon: "Stamp" },
];

// Horaires d'ouverture communs à tous les centres.
export const HORAIRES = "Du lundi au vendredi, de 9h30 à 17h30";

// Certification Qualiopi.
export const QUALIOPI = {
  perimetre: "Actions de formation",
  numero: "Certificat Qualiopi délivré au titre des Actions de formation",
};

// Référent handicap.
export const REFERENT_HANDICAP = {
  nom: "Manon Michelis",
  telephone: "06 98 55 80 31",
  email: "manon.michelis@educaser.fr",
};

